import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React from 'react';

interface HeaderProps {
  title: string;
  description?: string;
  /** Page-level actions, rendered on the right. */
  children?: React.ReactNode;
}

/**
 * Page header. Insight puts breadcrumbs here; this panel is flat — four pages, no
 * nesting — so the title carries the same slot instead.
 */
const Header: React.FC<HeaderProps> = ({ title, description, children }) => {
  return (
    <Stack direction='row' sx={headerStackStyles} spacing={2}>
      <Stack>
        <Typography variant='h5' sx={{ fontWeight: 600 }}>{title}</Typography>
        {description && (
          <Typography variant='body2' sx={{ color: 'text.secondary', mt: 0.5 }}>
            {description}
          </Typography>
        )}
      </Stack>
      <Stack direction='row' sx={{ gap: 1, alignItems: 'center' }}>
        {children}
      </Stack>
    </Stack>
  );
};

const headerStackStyles = {
  display: 'flex',
  width: '100%',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  paddingTop: 4.5,
  paddingBottom: '26px',
};

export default Header;
